import { DomainActionTypes } from '../constants/ApiConstants';

const initialState = {
    master_data: [],
    loading: false,
    domainList: null,
    domainListDetails: null,
    deleted_domainList: null,
    saved_domainList: null,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DomainActionTypes.get_domainList.REQUEST:
            return {
                ...state, 
                loading: true,
                domainList: null
            };
        case DomainActionTypes.get_domainList.SUCCESS:
            return {
                ...state,
                loading: false,
                domainList: payload
            };
        case DomainActionTypes.get_domainDetails.REQUEST:
            return {
                ...state,
                loading: true,
                domainListDetails: null
            };
        case DomainActionTypes.get_domainDetails.SUCCESS:
            return {
                ...state,
                loading: false,
                domainListDetails: payload
            };
        case DomainActionTypes.post_domain.REQUEST:
            return {
                ...state,
                loading: true,
                saved_domainList: null
            };
        case DomainActionTypes.post_domain.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_domainList: payload
            };
        case DomainActionTypes.delete_domain.REQUEST:
            return {
                ...state,
                loading: true,
                deleted_domainList: null
            };
        case DomainActionTypes.delete_domain.SUCCESS:
            return {
                ...state,
                loading: false,
                deleted_domainList: payload
            };
        case DomainActionTypes.get_master_data.REQUEST:
            return {
                ...state,
                loading: true,
                master_data: null,
            };
        case DomainActionTypes.get_master_data.SUCCESS:
            return {
                ...state,
                loading: false,
                master_data: payload,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/domain/reducers/domainReducer.js